<template>
  <div class="container">
    <div class="content">
      <!-- <div class="title">完善下列信息，您将获得一张<span style="color: #B3212D;">{{coupuntxt}}</span>的优惠券，然后你就可以一分钱学习其中的干货啦~</div> -->
      <div class="title">完善下列信息，你将获得1张优惠券~</div>
      <div class="title" style=" padding-top: 15px;">祝你成功噻~</div>
      <div class="title" style=" padding-top: 15px;">任何懵逼都可以&nbsp;&nbsp;随时随地&nbsp;&nbsp;联系小姨妈微信：</div>
      <div class="title1"  v-clipboard:copy="'xiaoyimawork'" v-clipboard:success="onCopy">xiaoyimawork</div>
      <div class="item">
          <div class="item_grey" v-if="job_type==''||job_type==null" @click="unitVisible(1)">校招还是社招</div>
          <div class="item_style" v-if="job_type!=''"  @click="unitVisible(1)">{{job_type}}</div>
        <!-- <input class="item_style" placeholder="校招还是社招" v-model="job_type" type="text"> -->
      </div>
      <div class="item">
          <div class="item_grey" v-if="edu_year==''||edu_year==null" @click="year">哪一年毕业？</div>
          <div class="item_style" v-if="edu_year!=''"  @click="year">{{edu_year}}</div>
      </div>
      <div class="item">
        <div class="item_grey" v-if="school_name==''||school_name==null" @click="toschool()">学校名称</div>
        <div class="item_style" v-if="school_name!=''"  @click="toschool()">{{school_name}}</div>
        <!-- <input class="item_style" placeholder="学校名称" v-model="school_name" type="text"> -->
      </div>
      <div class="item">
        <!-- <div class="item_grey" v-if="subject==''||subject==null" @click="unitVisible(2)">专业名称</div>
          <div class="item_style" v-if="subject!=''"  @click="unitVisible(2)">{{subject}}</div> -->
        <input class="item_style" placeholder="专业名称" v-model="subject" type="text">
      </div>
      <div class="item">
        <div class="item_grey" v-if="education==''||education==null" @click="unitVisible(3)">学历</div>
          <div class="item_style" v-if="education!=''"  @click="unitVisible(3)">{{education}}</div>
        <!-- <input class="item_style" placeholder="学历" v-model="education" type="text"> -->
      </div>
      <div class="item">
        <div class="item_grey" v-if="trade==''||trade==null" @click="unitVisible(2)">专业名称</div>
        <div class="item_style" v-if="trade!=''"  @click="unitVisible(2)">{{trade}}</div>
        <!-- <input class="item_style" placeholder="意向行业" v-model="trade" type="text"> -->
      </div>
      <div class="item">
        <input class="item_style" placeholder="意向岗位" v-model="work" type="text">
      </div>
      <div class="item">
        <input class="item_style" placeholder="微信号(主要怕你买了干货遇到问题找不到小姨妈)" v-model="wechat" type="text">
      </div>

      <mt-popup style="width: 100vw" position="bottom" v-model="popupVisible1">
        <mt-picker :slots="Slots1" :show-toolbar="true" @change="unitConfirm"  ref="picker1">
          <!-- <mt-button @click="unitChangeConfirm" class="sure">确认</mt-button> -->
        </mt-picker>
      </mt-popup>
      <mt-popup style="width: 100vw" position="bottom" v-model="popupVisible2">
        <mt-picker :slots="Slots2" :show-toolbar="true" @change="unitConfirm"  ref="picker2">
          <!-- <mt-button @click="unitChangeConfirm" class="sure">确认</mt-button> -->
        </mt-picker>
      </mt-popup>
      <mt-popup style="width: 100vw" position="bottom" v-model="popupVisible3">
        <mt-picker :slots="Slots3" :show-toolbar="true" @change="unitConfirm"  ref="picker3">
          <!-- <mt-button @click="unitChangeConfirm" class="sure">确认</mt-button> -->
        </mt-picker>
      </mt-popup>

      <mt-datetime-picker
        ref="day"
        type="date"
        year-format="{value} 年"
        :startDate="new Date(2001,0,0)"
        :endDate="new Date(new Date().getFullYear()+5,0,0)"
        v-model="mytime"
        @confirm="dayConfirm"
     ></mt-datetime-picker>
      <div class="btn" @click="update">提交</div>
      
    </div>
  </div>
</template>
<style scoped>
input::-webkit-input-placeholder { 
/* WebKit browsers */ 
color: rgb(132,132,132); 
} 
input:-moz-placeholder { 
/* Mozilla Firefox 4 to 18 */ 
color: rgb(132,132,132); 
} 
input::-moz-placeholder { 
/* Mozilla Firefox 19+ */ 
color: rgb(132,132,132); 
} 
input:-ms-input-placeholder { 
/* Internet Explorer 10+ */ 
color: rgb(132,132,132); 
}
.sure{
    color: #333;
    font-size: 18px;
    position: absolute;
    top: 0;
    right: 0;
    /* left: (600 / 75) rem; */
}
.container{
  overflow-y: scroll;
  /* font-family:Helvetica, Tahoma, Arial, "PingFang SC", "Hiragino Sans GB", "Heiti SC", "Microsoft YaHei", "WenQuanYi Micro Hei"; */
  background-color: #fff;
  color: rgb(34,34,34);
}
.item_grey{
  color: rgb(132,132,132); 
  font-size: 14px;
  width: 100%;
  padding-left: 15px;
}
.btn{
  width:300px ;
  height: 35px;
  line-height: 35px;
  text-align: center;
  background-color: #B3212D;
  color: #FFF;
  font-size: 16px;
  border-radius: 14px;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  top: 35px;
  margin-bottom: 60px;
}
.content{
  width: 100%;
  background-color: #fff;
  padding-left: 30px;
  padding-right: 30px;
  box-sizing: border-box;
   padding-top: 30px;
}
.title{
  font-size: 14px;
  line-height: 30px;
  font-weight: bold;
  color: rgb(34,34,34);
}
.title1{
  font-size: 14px;
  line-height: 30px;
  font-weight: bold;
  color: #B3212D;
}
.item{
  display: flex;
  align-items: center;
  height: 35px;
  margin-top: 15px;
  border: 1px solid#e7e7e7;
  border-radius: 8px;
}
.item_style{
  border: 0;
  outline: 0;
  width: 100%;
  padding-left: 15px;
  color: rgb(34,34,34);
  font-size: 14px;
  box-shadow: none;
  text-shadow: none ;
  -webkit-apprarance:none;
}
.item_left{
  display: flex;
  flex-direction: row;
  align-items: center;
}
.learn_title{
  font-size: 16px;
  color: rgb(34,34,34);
  line-height: 36px;
  font-weight: 600;
}
.learn_process{
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 40px;
}
.learn_icon{
  width: 26px;
  height: 26px;
  margin-right: 5px;
  margin-left: 12px;
}
.learn_font{
  font-size: 12px;
  color: rgb(34,34,34);
  margin-right: 12px;
  font-weight: bold;
}
.item_icon{
  width: 18px;
  height:18px;
  margin-right: 6px;
}
.right_icon{
  width: 8px;
  height: auto;
}
.item_font{
  font-size: 12px;
  color: rgb(34,34,34);
}

</style>

<script>
import { mylabel,updatemylabel } from '../apollo/apollo'
import { Picker,DatetimePicker} from 'mint-ui';

export default {
  components: {
    [Picker.name]: Picker,
    [DatetimePicker.name]: DatetimePicker
  },
  data() {
    return {
      rightImg:'./static/imgs/right.png',
      mylabel:mylabel,
      updatemylabel:updatemylabel,
      getUserFlag:{},
      job_type:'',
      school_name:'',
      subject:'',
      education:'',
      trade:'',
      work:'',
      wechat:'',
      edu_year:'',
      updateCoupon:{},//红包信息
      coupuntxt:'',
      popupVisible1:false,
      popupVisible2:false,
      popupVisible3:false,
      List:['校招','社招'],
      getIndustry:[],//获取行业列表
      getEducational:[]//学历列表
    }
  },
  computed:{
        Slots1() {
        let units = [
            {
            flex: 1,
            values: this.List,
            className: "Pslot",
            textAlign: "center"
            }
        ];
        return units;
        },
        Slots2() {
        let units = [
            {
            flex: 1,
            values: this.getIndustry,
            className: "Pslot",
            textAlign: "center"
            }
        ];
        return units;
        },
        Slots3() {
        let units = [
            {
            flex: 1,
            values: this.getEducational,
            className: "Pslot",
            textAlign: "center"
            }
        ];
        return units;
        },

        
    },
  created() {
    this.mytime=new Date()
    this.initDate()
  },
  mounted(){
 
  },
  methods: {
    year() {
	            //打开年历控件，顺序不要反，要先创建日历才能选中日历元素
	            this.$refs.day.open();
              //获取年历日月元素并影藏  //2是日元素、1是月元素、0是年元素
	             this.$refs.day.$el.getElementsByClassName('picker-slot')[2].style.display = 'none'
	             this.$refs.day.$el.getElementsByClassName('picker-slot')[1].style.display = 'none'
     },
     dayConfirm(value){
        this.edu_year = value.getFullYear();
     },
    toschool(){
      this.$store.state.schoolFlag=1
      this.$store.state.news.job_type=this.job_type
      this.$store.state.news.subject=this.subject
      this.$store.state.news.education=this.education
      this.$store.state.news.trade=this.trade
      this.$store.state.news.work=this.work
      this.$store.state.news.wechat=this.wechat
       this.$store.state.news.edu_year=this.edu_year
      this.jump('./schoolSearch')
    },
    unitVisible(x){
      this.$store.state.x=x
      if(x==1){
         this.popupVisible1=true;
      }else if(x==2){
         this.popupVisible2=true;
      }else if(x==3){
         this.popupVisible3=true;
      }
    },
    unitConfirm(){
      if(this.$store.state.x==1){
        this.job_type=this.$refs.picker1.getValues()[0];
      }else if(this.$store.state.x==2){
        this.trade=this.$refs.picker2.getValues()[0];
      }else if(this.$store.state.x==3){
        this.education=this.$refs.picker3.getValues()[0];
      }
      this.popupVisible1=false;
      this.popupVisible2=false;
      this.popupVisible3=false;
    },
    unitChangeConfirm(){
      this.popupVisible1=false;
      this.popupVisible2=false;
      this.popupVisible3=false;
    },
     onCopy(){
      this.showOneBtnAlert('已成功复制小姨妈微信')
    },
    initDate(){
      document.title=this.$store.state.title;
      mylabel().then(res=>{
        if(this.$store.state.schoolFlag==0){
          this.updateCoupon=res.data.getUpdateCoupon
          this.job_type=res.data.getUserFlag.job_type;
          this.school_name=res.data.getUserFlag.school_name;
          this.subject=res.data.getUserFlag.subject;
          this.education=res.data.getUserFlag.education;
          this.trade=res.data.getUserFlag.trade;
          this.work=res.data.getUserFlag.work;
          this.wechat=res.data.getUserFlag.wechat;
          this.edu_year=res.data.getUserFlag.edu_year;
          this.$store.state.news.school_name=this.school_name
        }else{
          this.job_type=this.$store.state.news.job_type
          this.school_name=this.$store.state.news.school_name
          this.subject=this.$store.state.news.subject
          this.education=this.$store.state.news.education
          this.trade=this.$store.state.news.trade
          this.work=this.$store.state.news.work
          this.wechat=this.$store.state.news.wechat
          this.edu_year=this.$store.state.news.edu_year;
        }
        
        if(this.updateCoupon.use_type==1){
          this.coupuntxt=this.updateCoupon.reduce+'元'
        }else if(this.updateCoupon.use_type==2){
          this.coupuntxt=this.updateCoupon.discount+'折'
        }
        res.data.getIndustry.map((e,i)=>{
          this.getIndustry.push(e.name)
        })
        res.data.getEducational.map((e,i)=>{
          this.getEducational.push(e.name)
        })
        
        })
        .catch(err=>{
          this.msgManage(err)
        })
    },

    update(){
      if(this.job_type==''||this.job_type==null){
        this.showOneBtnAlert('校招还是社招不能为空！')
        return;
      }
      if(this.school_name==''||this.school_name==null){
        this.showOneBtnAlert('学校名称不能为空！')
        return;
      }
      if(this.subject==''||this.subject==null){
        this.showOneBtnAlert('专业名称不能为空！')
        return;
      }
      if(this.education==''||this.education==null){
        this.showOneBtnAlert('学历不能为空！')
        return;
      }
      if(this.trade==''||this.trade==null){
        this.showOneBtnAlert('意向行业不能为空！')
        return;
      }
      if(this.work==''||this.work==null){
        this.showOneBtnAlert('意向岗位不能为空！')
        return;
      }
      if(this.wechat==''||this.wechat==null){
        this.showOneBtnAlert('微信号不能为空！')
        return;
      }
      var formDate={
        job_type:this.job_type+"",
        school_name:this.school_name+"",
        subject:this.subject+"",
        education:this.education+"",
        trade:this.trade+"",
        work:this.work+"",
        wechat:this.wechat+"",
        edu_year:this.edu_year+"",
      }

      updatemylabel(formDate).then(res=>{
        if(JSON.parse(res.data.updateUserFlag).code==200){
          this.showOneBtnConfirm('提交成功',()=>{
            this.$store.state.news={}
            this.$store.state.schoolFlag=0
            this.jump('./index')  
          })
              
            
        }else{
          this.showOneBtnAlert(JSON.parse(res.data.updateUserFlag).msg)
        }   
      })
      .catch(err=>{
          this.msgManage(err)
        })
    }



  }, 
  destroyed () {  
      
    
  },
  watch:{
    
  }
};
</script>


// WEBPACK FOOTER //
// src/views/mylabel.vue